import type {ReactElement} from 'react';
import {useState} from 'react';
import type {AnimatedSprite} from '@Libraries/animated-sprite.library';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import type {GridItemProps} from '../grid-item';
import type {GridMediaItemStorage} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import styles from './grid-animated-sticker-item.module.scss';

export interface GridAnimatedStickerItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
  duration: number;
  frameRate: number;
  highResAnimatedSprite: AnimatedSprite;
  screenAnimatedSprite: AnimatedSprite;
}

interface GridStickerItemProps extends GridItemProps {
  videoThumbSrc?: string;
}

export interface GridAnimatedStickerItemBackEndData {
  id: string;
  hidden: boolean;
  hashedFilename: string;
  duration: string;
  frameRate: string;
}

/**
 * @class GridAnimatedStickerItem
 */
export function GridAnimatedStickerItem({...props}: GridStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);

  const getThumbElement = (): ReactElement<any> => {
    return (
      <img
        onLoad={(): void => {
          setIsImageLoaded(true);
          void isStockItemPredominantlyWhite(props.videoThumbSrc ?? '').then(setHasGrayBackground);
        }}
        className={styles.thumb}
        draggable="false"
        src={props.videoThumbSrc}
        alt={window.i18next.t('pmwjs_sticker')}
      />
    );
  };

  return <GridMediaItem {...props} isImageLoaded={isImageLoaded} hasGrayBackground={hasGrayBackground} thumb={getThumbElement()} />;
}
